import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

import { EstimateCreatedV1DataSchema } from "./estimate-review-shared";

export const SowChangeSupplementEstimateTaskAttemptSchema = z.object({
  type: z.literal(TaskType.SOW_CHANGE_SUPPLEMENT_ESTIMATE),
  data: z.discriminatedUnion("version", [EstimateCreatedV1DataSchema]),
});
